import React, { useState } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const UpdateSchedule = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // State to hold form data
  const [formData, setFormData] = useState({
    name: "",
    remark: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  const [fetchLoading, setFetchLoading] = useState(true);

  // Fetch schedule data on component mount
  React.useEffect(() => {
    fetchScheduleData();
  }, []);

  const fetchScheduleData = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      return;
    }

    setFetchLoading(true);
    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/CatalogSchedulerOperation/Search',
        {
          id: parseInt(id)
        },
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );

      if (response.data && response.data.data && response.data.data.length > 0) {
        const schedule = response.data.data[0];
        setFormData({
          name: schedule.name || "",
          remark: schedule.remark || "",
          active: schedule.active !== undefined ? schedule.active : true
        });
      } else {
        setMessage("Schedule not found");
      }
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      setMessage("Failed to fetch schedule data");
    } finally {
      setFetchLoading(false);
    }
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const dataToSend = {
      id: parseInt(id),
      active: formData.active,
      name: formData.name,
      remark: formData.remark
    };

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/CatalogSchedulerOperation/Update',
        dataToSend,
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );

      if (response.data && response.data.isresponse) {
        setMessage("Schedule updated successfully!");
      } else {
        setMessage(response.data?.errormsg || "Failed to update schedule");
      }
    } catch (error) {
      console.error("Error updating schedule:", error);
      setMessage(error.response?.data?.message || "Failed to update schedule");
    }

    // Navigate to another page after 3 seconds
    setTimeout(() => {
      navigate("/schedulelist");
    }, 3000);
  };

  if (fetchLoading) {
    return (
      <>
        <Menu />
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content">
              <div className="container-fluid">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Update Schedule</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Schedule Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter schedule name"
                                name="name"
                                required
                                readOnly
                                style={{ 
                                  backgroundColor: 'var(--surface2)',
                                  color: 'var(--text)',
                                  border: '1px solid var(--border)'
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Schedule Description</label>
                              <textarea
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter description"
                                name="remark"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="active"
                                  name="active"
                                  checked={formData.active}
                                  onChange={handleChange}
                                />
                                <label className="custom-control-label" htmlFor="active">
                                  Active
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Update
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Schedule updated successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to update schedule." ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default UpdateSchedule;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
